import { render, staticRenderFns } from "./ClientsClientTeam.vue?vue&type=template&id=66b0378c&scoped=true"
import script from "./ClientsClientTeam.vue?vue&type=script&lang=js"
export * from "./ClientsClientTeam.vue?vue&type=script&lang=js"
import style0 from "./ClientsClientTeam.vue?vue&type=style&index=0&id=66b0378c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b0378c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
